import { getRuntimeConfigOrDefault } from '../utils/runtime-config';
import mapboxgl from 'mapbox-gl';

// Get Mapbox token from runtime config or fallback to process.env
export const MAPBOX_ACCESS_TOKEN = getRuntimeConfigOrDefault(
  'REACT_APP_MAPBOX_TOKEN',
  'pk.eyJ1IjoiZGRkaW1jaGEiLCJhIjoiY2xxY2lidHMzMDJtaTJsbzd6YmpwcXBxcyJ9.t_ZL9iOZplyHoP1i1dKh_w'
);

// Set the access token globally
mapboxgl.accessToken = MAPBOX_ACCESS_TOKEN;